import { FolderOpen, Pencil, Trash2 } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMedia, resolveMediaCarBrand } from "../../services/api";

export default function OrderTypeRow({ ordertype, onEdit, onDelete }) {
  const avatar = resolveMediaCarBrand(
    ordertype?.logo,
    defaultAvatar
  );

  return (
    <tr>
      {/* MARQUE */}
      <td>
        <div className="userCell">
          <img src={avatar} alt="avatar"  className="tableAvatar" />
          <div>
            <div className="userName">{ordertype?.name}</div>
            <div className="userSub">{ordertype?.id}</div>
          </div>
        </div>
      </td>

      <td>
        <div>{ordertype?.description || "-"}</div>
      </td>

    
    </tr>
  );
}
